export default __webpack_public_path__ + "static/manos-7aa40650c72177cd0ece54715dd0e119.png";